export default [{
	titulo: 'Gestões',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/gestoes',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]